import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/',
    redirect: '/payment'
  },
  {
    path: '/bookings',
    name: 'BookingUniversalBoard',
    component: () => import('./components/board/BookingUniversalBoard.vue'),
  },
  {
    path: '/users',
    name: 'UserAdmin',
    component: () => import('./components/board/UserAdmin.vue'),
  },
  {
    path: '/racks',
    name: 'AdminRackBoard',
    component: () => import('./components/board/AdminRackBoard.vue'),
  },
  {
    path: '/qrs',
    name: 'AdminQRsBoard',
    component: () => import('./components/board/AdminQRsBoard.vue'),
  },
  {
    path: '/devices',
    name: 'AdminDevicesBoard',
    component: () => import('./components/board/AdminDevicesBoard.vue'),
  },
  {
    path: '/installations',
    name: 'AdminInstallationsBoard',
    component: () => import('./components/board/AdminInstallationsBoard.vue'),
  },
  {
    path: '/openlocker',
    name: 'OpenLocker',
    component: () => import('./components/form/OpenLocker.vue'),
  },
  {
    path: '/fast-booking',
    name: 'AdminFastBooking',
    component: () => import('./components/board/AdminFastBooking.vue'),
  },
  {
    path: '/lockers',
    name: 'LockersContent',
    component: () => import('./components/content/LockersContent.vue'),
  },
  {
    path: '/infrastructure',
    name: 'InfrastructureContent',
    component: () => import('./components/content/InfrastructureContent.vue'),
  },
  {
    path: '/coupons',
    name: 'CouponContent',
    component: () => import('./components/content/CouponContent.vue'),
  },
  {
    path: '/audit',
    name: 'AdminAuditBoard',
    component: () => import('./components/board/AdminAuditBoard.vue'),
  },
  {
    path: '/admins',
    name: 'AdminUsersManagementBoard',
    component: () => import('./components/board/AdminUsersManagementBoard.vue'),
  },
  {
    // Acceso local (K3, solo SUPER_ADMIN). El menú lo pone el frontend padre (iframe a esta ruta).
    path: '/local-access',
    name: 'AdminLocalAccessBoard',
    component: () => import('./components/board/AdminLocalAccessBoard.vue'),
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
